import React, { useState } from 'react';
import { FaTruckMoving, FaSuitcase, FaClipboardList, FaChevronDown } from "react-icons/fa";

function BusinessSameDayService() {
  const [openFAQ, setOpenFAQ] = useState(null); // To track which FAQ is open

  const businessServices = [
    {
      service: "Two-Man Delivery",
      description: "Perfect for heavier or bulkier items requiring extra support. Ensure secure delivery with our specialized two-man service.",
      icon: <FaTruckMoving className="w-16 h-16 text-black" />,
    },
    {
      service: "Airport Services",
      description: "Fast and efficient courier services to and from airports, ensuring your packages catch the next flight.",
      icon: <FaSuitcase className="w-16 h-16 text-black" />,
    },
    {
      service: "Forgotten Items",
      description: "Retrieve forgotten items like phones, laptops, or documents and have them delivered the same day.",
      icon: <FaClipboardList className="w-16 h-16 text-black" />,
    },
    {
      service: "Dedicated Overnight Delivery",
      description: "For those urgent deliveries that can’t wait till morning. We’ll get your package delivered overnight.",
      icon: <FaTruckMoving className="w-16 h-16 text-black" />,
    },
    {
      service: "Urgent Document Delivery",
      description: "Secure and rapid delivery of important documents within the same day.",
      icon: <FaSuitcase className="w-16 h-16 text-black" />,
    },
    {
      service: "Urgent Pallet Delivery",
      description: "Quick delivery of pallets, with access to a dedicated fleet, ensuring no client is left waiting.",
      icon: <FaClipboardList className="w-16 h-16 text-black" />,
    },
  ];
  

  const handleFAQClick = (index) => {
    setOpenFAQ(openFAQ === index ? null : index); // Toggle open FAQ
  };

  return (
    <div>
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center h-[400px] md:h-[700px]"
        style={{ backgroundImage: "url('images/sameday2.jpeg')" }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
          <h1 className="text-4xl md:text-7xl xl:text-8xl font-semibold">Business Same Day Services</h1>
        </div>
      </div>

      {/* Introduction Section */}
      <section className="py-10 px-6 text-center bg-white text-black">
        <p className="text-lg leading-relaxed max-w-6xl mx-auto font-thin">
          Imagine the scene... You're rushing to the office, when you realize you forgot your phone, laptop, or important documents. Or maybe you are already at the office and realize you didn't book that courier you were meant to the day before. Whatever the delivery item may be, we have all the courier services you need to help support your business.
        </p>
        <p className="text-lg leading-relaxed max-w-6xl mx-auto mt-6 font-thin">
          Poor planning can lead to stressful and expensive situations. We provide a quick and reliable service for businesses. Whether you want to quickly pick up the phone and book an urgent delivery or you require a more bespoke or selected service that requires more support.
        </p>
      </section>

      {/* Business Services Section */}
      <section id="business-services" className="py-16 bg-white text-black">
        {/* <h2 className="text-3xl md:text-5xl font-bold text-center mb-8">Our Services</h2> */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center px-4">
          {businessServices.map((service, index) => (
            <div key={index} className="flex flex-col gap-6 items-center text-center mt-6">
              <div className="mb-2 text-red-500">{service.icon}</div>
              <h3 className="text-2xl font-thin mb-1">{service.service}</h3>
              <p className="text-zinc-400 max-w-sm font-thin">{service.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Special Features Section */}
      <section className="py-10 px-6 text-center bg-white text-black">
        <h2 className="text-3xl font-thin mb-6">Why Choose Us?</h2>
        <p className="text-lg leading-relaxed max-w-3xl mx-auto font-thin">
          We have access to over 3000 drivers, which allows us to offer a collection time within 60 minutes from quote approval. Whether it's urgent document delivery or overnight pallet services, we ensure reliability and speed.
        </p>
      </section>

      {/* FAQs */}
      <section className="py-10 px-6 bg-white">
        <h2 className="text-3xl font-thin text-center mb-6">Frequently Asked Questions</h2>
        <div className="max-w-4xl mx-auto">
          {["I need documents delivered urgently", "I need a pallet delivered overnight"].map((faq, index) => (
            <div key={index} className="mb-4">
              <div
                className="flex justify-between items-center bg-white p-4 shadow-md cursor-pointer"
                onClick={() => handleFAQClick(index)}
              >
                <h3 className="text-lg font-thin">{faq}</h3>
                <FaChevronDown
                  className={`transition-transform duration-300 ${
                    openFAQ === index ? "transform rotate-180" : ""
                  }`}
                />
              </div>
              {openFAQ === index && (
                <div className="bg-gray-100 p-4 text-sm font-thin">
                  {index === 0 && (
                    <p>
                      No need to stress, all you need to do is arrange a pickup point for the documents. We promise to pick them up from any location in Mainland UK within 60 minutes and have it delivered to your chosen address on the same day.
                    </p>
                  )}
                  {index === 1 && (
                    <p>
                      We understand that jobs can change all the time, and last-minute deliveries are required every day. That's why we have a dedicated pallet delivery team with access to a fleet of vehicles, including Artic lorries, that can deliver up to 26 standard UK pallets. We can pick up your goods and deliver them on the same day or through the night, so you never have to disappoint your client with job delays.
                    </p>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default BusinessSameDayService;
